import type { LessonPlanRole } from "../object-actions/types/types";

const ADULT_WAIVER = "eula.md";
const DEFAULT_ATHLETE_WAIVER = "eula.md";

export interface OrgWaiverConfig {
    waiver_athlete?: string | null;
    waiver_adult?: string | null;
    /** @deprecated use waiver_athlete */
    waiver_name?: string | null;
}

export interface WaiverRequiredPayload {
    waiver_required?: boolean;
    /** Set when another party (e.g. the athlete) must sign, not the current user. */
    athlete_waiver_required?: boolean;
    required_waiver?: string;
    /** Role whose waiver is owed, when the endpoint knows it. */
    waiver_role?: LessonPlanRole | string | null;
    assignment_id?: number;
    error?: string;
}

export function orgAthleteWaiverFile(org?: OrgWaiverConfig | null): string {
    return org?.waiver_athlete || DEFAULT_ATHLETE_WAIVER;
}

export function orgAdultWaiverFile(org?: OrgWaiverConfig | null): string {
    return org?.waiver_adult || ADULT_WAIVER;
}

export function waiverFileForRole(
    role: LessonPlanRole | string | null | undefined,
    org?: OrgWaiverConfig | null,
): string {
    if (role === "athlete") {
        return orgAthleteWaiverFile(org);
    }
    return orgAdultWaiverFile(org);
}

export function dispatchOpenWaiver(detail: {
    role?: LessonPlanRole | string | null;
    assignmentId?: number | null;
}) {
    if (typeof window === "undefined") return;
    window.dispatchEvent(
        new CustomEvent("smsp:open-waiver", {
            detail: {
                role: detail.role ?? null,
                assignmentId: detail.assignmentId ?? null,
            },
        }),
    );
}

export function handleWaiverRequiredPayload(
    payload: WaiverRequiredPayload | null | undefined,
    fallbackRole?: LessonPlanRole | string | null,
    fallbackAssignmentId?: number | null,
): boolean {
    if (!payload?.waiver_required) return false;
    dispatchOpenWaiver({
        role: payload.waiver_role ?? fallbackRole ?? null,
        assignmentId: payload.assignment_id ?? fallbackAssignmentId ?? null,
    });
    return true;
}

export function isWaiverRequiredOnAssignment(assignment: {
    waiver_required?: boolean;
    my_roles?: string[];
} | null | undefined): boolean {
    if (!assignment) return false;
    if (typeof assignment.waiver_required === "boolean") {
        return assignment.waiver_required;
    }
    return false;
}
